/* eslint-disable camelcase */
/* eslint-disable no-underscore-dangle */
import React, { useContext, useMemo } from 'react';
import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { whenSideBySide, assignFormDesignToCSSVars } from '../fields-customise.style';
import SpecialPropsIndicators from '../props-Indicator/special-props';
import { FormContext } from '../../../shared/contexts/form-context';
import { ctrlDefaults } from '../../../../shared/form-lib';
import { selectCtrlIdLabelMap } from '../../selectors';
import { ControlPropType } from '../../ctrl_proptype';
import StripeSubComponent from './stripe-sub';
import {
  ValidationWarning,
  MainfieldWrapper,
  SubtextWrapper,
  FieldWrapper,
  LabelWrapper,
  InputWrapper,
  Field,
} from '../../common-field-styles';

const Stripe = ({ ctrl, formDesign, isRenderedOnModal }) => {
  const ctrlIdLabelMap = useSelector(selectCtrlIdLabelMap);
  const fieldLabel = ctrlIdLabelMap?.[ctrl.internal_id];
  const { inBuilder, inForm } = useContext(FormContext);
  const {
    editableForm: { stripe_public_key },
    isPayOnSubmission,
  } = useSelector((state) => state.form);

  let stripePromise = null;
  if (inForm && stripe_public_key) {
    stripePromise = useMemo(() => loadStripe(stripe_public_key), []);
  }

  return (
    <MainfieldWrapper tabIndex="0" style={assignFormDesignToCSSVars(inBuilder, formDesign)}>
      <FieldWrapper>
        {ctrl._validationError && (
          <ValidationWarning className="ui bottom pointing basic label red">{ctrl._validationError}</ValidationWarning>
        )}

        <Field className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
          {!ctrl.props.is_inventory_payment && !isPayOnSubmission && (
            <LabelWrapper
              className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}
              required={ctrl.props.required}
              notInBuilder={!inBuilder}>
              <label dangerouslySetInnerHTML={{ __html: fieldLabel || ctrlDefaults()[ctrl.type] }} />
              <SpecialPropsIndicators ctrl={ctrl} />
            </LabelWrapper>
          )}

          <InputWrapper className={!inBuilder ? whenSideBySide(ctrl, formDesign) : ''}>
            <Elements stripe={stripePromise}>
              <StripeSubComponent ctrl={ctrl} formDesign={formDesign} isRenderedOnModal={isRenderedOnModal} />
            </Elements>
            
            <SubtextWrapper id="descriptive text" notInBuilder={!inBuilder}>
              {ctrl.props.subtext}
            </SubtextWrapper>
          </InputWrapper>
        </Field>
      </FieldWrapper>
    </MainfieldWrapper>
  );
};

Stripe.defaultProps = {
  isRenderedOnModal: false,
  formDesign: null,
};

Stripe.propTypes = {
  isRenderedOnModal: PropTypes.bool,
  ctrl: PropTypes.shape(ControlPropType).isRequired,
  formDesign: PropTypes.shape({
    old: PropTypes.object.isRequired,
    design: PropTypes.object.isRequired,
  }),
};

export default Stripe;
